import { ServiceChargeDto, ServiceChargeMode } from '@up/data';

export const applyServiceChargeBasedOnMode = (
  serviceCharge: ServiceChargeDto,
  total: number
): number => {
  if (total === 0) {
    return 0;
  }

  const resultAfterDiscount =
    ServiceChargeMode[serviceCharge.serviceChargeModeId] === ServiceChargeMode[1] ?
      (serviceCharge.percent / 100) * total : serviceCharge.percent;

  return +resultAfterDiscount.toFixed(2);
};
